// PREZZO DEL SOL, SOLO PER LE ETICHETTE
//
// L'economia del gioco e' in SOL dall'inizio alla fine: questo prezzo non entra
// in nessun calcolo che muove denaro. Serve unicamente ad affiancare una stima
// in dollari ai valori mostrati, perche' "0,025 SOL" da solo dice poco a chi
// non segue il cambio.
//
// Conseguenza voluta: se CoinGecko non risponde, sparisce la stima in dollari e
// **non succede nient'altro**. Nessun prezzo di riserva inventato, che sarebbe
// sbagliato per definizione e darebbe al giocatore un numero falso con l'aria
// di essere vero.
//
// Una sola richiesta condivisa da tutta l'app: prima la lobby e la scena di
// gioco la facevano ognuna per conto suo.

const URL = 'https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd';
const VALIDITA_MS = 5 * 60 * 1000; // il cambio non si muove tanto in cinque minuti

let prezzo = null;
let letto = 0;
let inCorso = null;

// Prezzo gia' noto, senza attendere. `null` se non e' ancora disponibile.
export function prezzoSolCorrente() {
  return prezzo;
}

export async function getSolPrice() {
  if (prezzo !== null && Date.now() - letto < VALIDITA_MS) return prezzo;
  // Richieste concorrenti condividono la stessa chiamata.
  if (inCorso) return inCorso;

  inCorso = fetch(URL)
    .then((r) => r.json())
    .then((d) => {
      if (d && d.solana && typeof d.solana.usd === 'number') {
        prezzo = d.solana.usd;
        letto = Date.now();
      }
      return prezzo;
    })
    .catch(() => prezzo) // si tiene l'ultimo noto, o resta null
    .finally(() => { inCorso = null; });

  return inCorso;
}

// "0.025 SOL (~$5.00)", oppure solo "0.025 SOL" se il cambio non e' disponibile.
export function conStimaInDollari(sol, prezzoUsd = prezzo) {
  const valore = Number(sol) || 0;
  const testo = `${parseFloat(valore.toFixed(4))} SOL`;
  if (!prezzoUsd) return testo;
  return `${testo} (~$${(valore * prezzoUsd).toFixed(2)})`;
}
